// extracted by mini-css-extract-plugin
export default {"container":"ImageFluid_container__yWFUZ","image":"ImageFluid_image__BfIvD","text":"ImageFluid_text__mvwgv"};